import { useQuery } from '@tanstack/vue-query'

export function useTransportOperator() {
  const { $trpc } = useNuxtApp()

  const queryFn = async () => {
    return await $trpc.auctions.getTransportOperators.query()
  }

  return useQuery({
    queryKey: ['transport-operator'],
    queryFn,
  })
}
